<template lang="pug">
#Login.login.inside-padding
  form(@submit.prevent="")
    .form-section
      .input-container
        input.input(v-model="dataForm.dni" type="number" min="0" pattern="[0-9]" autocomplete="ño" :title="warnings.dni" :disabled="codeSent" required)
        label.label(:class="{show: dataForm.dni}") Cédula
      .input-container(v-if="codeSent")
        input.input(v-model="dataForm.code" type="number" min="100000" max="999999" pattern="[0-9]" autocomplete="ño" :title="warnings.verification" required)
        label.label(:class="{show: dataForm.code}") Código

    shActionButton(v-if="!codeSent" :isForm="true" text="Enviar Código" textRunning="Enviando..." :action="sendVerificationCode")
    shActionButton(v-if="codeSent" :isForm="true" text="Entrar" textRunning="Entrando..." :action="login")
    a.resend-link(v-if="codeSent" @click="resend") Reenviar código
</template>

<script>
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import gqlLogin from '@/graphql/login'
import gql from '@my/graphql'
import router from '@my/router'

export default {
  name: 'Login',

  mixins: [mForm],

  data () {
    return {
      dataForm: {
        dni: '',
        code: ''
      },
      codeSent: false
    }
  },

  methods: {
    async sendVerificationCode () {
      const response = await gql.query(gqlLogin.SEND_VERIFICATION_CODE, { dni: this.dataForm.dni })
      if (response) {
        modals.showMessage({ message: 'Código enviado por WhatsApp' })
        this.codeSent = true
      }
    },

    async login () {
      const variables = { dni: this.dataForm.dni, code: this.dataForm.code }
      const response = await gql.query(gqlLogin.LOGIN, variables)

      if (response) {
        const token = response.data.login

        this.$store.commit('login', token)
        this.$store.commit('getVariablesApp')
        this.$store.commit('connectSocket')
        modals.showMessage({ message: 'Te has logueado correctamente' })

        this.initForm()
        this.codeSent = false

        router.goToHome()
      }
    },

    resend () {
      this.codeSent = false
      this.dataForm.code = ''
    }
  }
}
</script>

<style lang="stylus">
.login
  position relative
  padding-bottom 1em

.resend-link
  display block
  margin-top 0.8em
  font-size 0.9em
  cursor pointer
  opacity 0.7
  text-align center
  &:hover
    opacity 1
</style>



// WEBPACK FOOTER //
// src/components/pages/login/Login.vue